import { i18n } from '@lingui/core';
import { Button } from '@warp-ds/react';
import React from 'react';
import { useAppConfig } from '../../AppConfig';
import { SavedSearch } from '../saved-search/SavedSearch';

type ZeroResultsProps = {
    className?: string;
};

export function ZeroResults(props: ZeroResultsProps) {
    const { className = '' } = props;

    const { assetsUrl } = useAppConfig();

    return (
        <div
            className={`${className} flex flex-col items-center justify-center w-full`}
        >
            <div className="flex flex-col items-center md:w-1/2 sm:w-full justify-center">
                <img
                    className="p-16"
                    src={`${assetsUrl}/zero-hits.svg`}
                    alt={i18n.t({
                        id: 'results.zero-results.alt-text',
                        message: 'No ads found',
                    })}
                />
                <h3 className="h3">
                    {i18n.t({
                        id: 'results.zero-results.heading',
                        message: 'No ads found',
                    })}
                </h3>
                <SavedSearch>
                    {({ isSaveable, onClick }) => (
                        <>
                            <p className="pb-16 text-s text-center">
                                {i18n.t({
                                    id: 'results.zero-results.information',
                                    message:
                                        'We cannot find the product you are looking for, it may already be sold. Would you like to be notified when there are new hits for this search?',
                                })}
                            </p>
                            <Button
                                disabled={!isSaveable}
                                onClick={onClick}
                                primary
                            >
                                {i18n.t({
                                    id: 'results.zero-results.button-label',
                                    message: 'Save search',
                                })}
                            </Button>
                        </>
                    )}
                </SavedSearch>
            </div>
        </div>
    );
}
